import type { ButterflyCategory } from '$lib/types';

type CategoriesTreeHandler = (id: number, data: ButterflyCategory[]) => ButterflyCategory[];

const getCategoriesTree: CategoriesTreeHandler = (id, data) => {
  const tree: ButterflyCategory[] = [];

  let from = data.find((c) => c.id === id);
  while (from) {
    tree.push(from);
    if (from.relationships.parentCategory.data) {
      from = data.find((c) => c.id === from?.relationships.parentCategory.data?.id);
    } else {
      from = undefined;
    }
  }
  return tree.reverse();
};

export default getCategoriesTree;
